var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpanddoenIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 15,
    viewBox: "0 0 9 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.20117 2.57617C4.35938 2.41797 4.62305 2.41797 4.78125 2.57617L8.17383 5.95117C8.33203 6.12695 8.33203 6.39062 8.17383 6.54883C7.99805 6.72461 7.73438 6.72461 7.57617 6.54883L4.5 3.47266L1.42383 6.54883C1.24805 6.72461 0.984375 6.72461 0.826172 6.54883C0.650391 6.39062 0.650391 6.12695 0.826172 5.96875L4.20117 2.57617Z",
    fill: "#171717"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.20117 12.6738L0.826172 9.29883C0.650391 9.14062 0.650391 8.87695 0.826172 8.70117C0.984375 8.54297 1.24805 8.54297 1.42383 8.70117L4.5 11.7949L7.57617 8.71875C7.73438 8.54297 7.99805 8.54297 8.17383 8.71875C8.33203 8.87695 8.33203 9.14062 8.17383 9.29883L4.78125 12.6738C4.62305 12.8496 4.35938 12.8496 4.20117 12.6738Z",
    fill: "#171717"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpanddoenIcon);
export default __webpack_public_path__ + "static/media/upanddoenIcon.d3a9c12dc55c88f81e4292668340ba66.svg";
export { ForwardRef as ReactComponent };